/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import InfoAction from './InfoAction/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaSelectOneValues from 'DesignSystem/TysiaSelectOne/TysiaSelectOneValues/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/AppointmentBookingStateUpdate/SourceTypes/Content",
  onChange
  
}) {
let sourceTypesValueData = fromData.useDataValue({ viewPath,
context: 'source_types',
})
let selectedEventDataSourcetypesValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'event.data.sourceTypes',
})
let selectedEventDataSourcetypesChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'event.data.sourceTypes',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 size="small"
 data="source_types"
 from={sourceTypesValueData}
 data="selected.event.data.sourceTypes"
 onChange={selectedEventDataSourcetypesChangeData}
 value={selectedEventDataSourcetypesValueData}
 marginTop={dtSpaceM}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
 alignItems="center"
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Select the scheduling source to trigger the automation"
/>
<InfoAction
{...childProps}
  viewPath={`${viewPath}/InfoAction`}
/>
</React.Fragment>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
<TysiaSelectOneValues
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneValues`}
/>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}